import React, { Component } from "react";
import {
  Layout,
  Page,
  Stack,
  Button,
  Spinner,
  Banner,
  TextStyle,
} from "@shopify/polaris";
import { API } from "aws-amplify";
import Swal from "sweetalert2";

let proState = {
  proStatus: false,
  isAuthenticating: true,
};

class Pro extends Component {
  constructor(props) {
    super(props);
    this.state = proState;
  }

  // When the component first loads
  componentDidMount() {
    API.get("api", "/status" + window.location.search)
      .then((response) => {
        this.setState({ isAuthenticating: false });
        if (response) {
          // If we got back a response an active charge ID is on record
          this.setState({ proStatus: true });
        }
      })
      .catch((error) => {
        console.log(error.response); // Otherwise log the error, if any
      });
  }

  // When the component unloads (page switch)
  componentWillUnmount() {
    // Remember our state for the next mount
    proState = this.state;
  }

  render() {
    const primaryAction = {
      content: this.state.proStatus ? "View Plans" : "Go Pro",
      onAction: () => {
        this.changePage("/pro");
      },
    };
    const secondaryActions = [
      {
        content: "Home",
        onAction: () => {
          this.changePage("/");
        },
      },
      {
        content: "FAQ",
        onAction: () => {
          this.changePage("/faq");
        },
      },
      {
        content: "Privacy Policy",
        onAction: () => {
          this.changePage("/terms");
        },
      },
    ];

    if (this.state.isAuthenticating) {
      // If the page hasn't loaded yet, show a placeholder spinner instead
      return (
        <Page
          title="View Plans"
          primaryAction={primaryAction}
          secondaryActions={secondaryActions}
        >
          <Banner status="critical">
            <TextStyle variation="strong">
              After much consideration, we have decided to sunset the app on the
              5th of October 2024. This app will cease to function on this date.
              We are currently creating a new app that will replace this one.
              And we will notify you once it is available. We apologize for any
              inconvenience this may cause.
            </TextStyle>
          </Banner>
          <div
            style={{
              paddingTop: 20,
            }}
          ></div>
          <Layout>
            <Layout.Section>
              <Stack alignment="center" distribution="center">
                <Spinner size="large" color="teal" />
              </Stack>
            </Layout.Section>
          </Layout>
        </Page>
      );
    }

    return (
      !this.state.isAuthenticating && (
        <Page
          title="View Plans"
          primaryAction={primaryAction}
          secondaryActions={secondaryActions}
        >
          <Layout>
            <Layout.Section>
              <Stack alignment="leading" distribution="center">
                <div className="pricing-plan">
                  <div className="type">
                    <p>Free Plan</p>
                  </div>
                  <div className="plan">
                    <div className="header">
                      <span>$</span>0<span> USD / per month</span>
                    </div>
                    <div className="content">
                      <ul>
                        <li>Manage 1 toast only</li>
                        <li>8 free presets to use</li>
                        <li>Customize your toast's appearance</li>
                        <li>
                          Show your toast on all pages, the homepage only, or
                          everywhere but the homepage
                        </li>
                      </ul>
                    </div>
                    <div className="price">
                      <Button
                        onClick={this.deactivatePlan}
                        destructive={this.state.proStatus}
                        disabled={!this.state.proStatus}
                      >
                        {this.state.proStatus
                          ? "Downgrade Plan"
                          : "Active Plan"}
                      </Button>
                    </div>
                  </div>
                </div>
                <div className="pricing-plan">
                  <div className="type standard">
                    <p>Pro Plan</p>
                  </div>
                  <div className="plan">
                    <div className="header">
                      <span>$</span>3<span> USD / per month</span>
                    </div>
                    <div className="content">
                      <ul>
                        <li>Everything from the free plan and...</li>
                        <li>Manage up to 25 toasts</li>
                        <li>10 pro-only presets with special backgrounds</li>
                        <li>
                          Show your toast on product pages only or custom page
                          targeting
                        </li>
                      </ul>
                    </div>
                    <div className="price">
                      <Button
                        onClick={this.activatePlan}
                        primary={!this.state.proStatus}
                        disabled={this.state.proStatus}
                      >
                        {this.state.proStatus ? "Active Plan" : "Go Pro"}
                      </Button>
                    </div>
                  </div>
                </div>
              </Stack>
            </Layout.Section>
          </Layout>
        </Page>
      )
    );
  }

  // Change our page, but only if our current page is done loading to prevent memory leaks
  changePage = (url, keepParams = true) => {
    this.props.history.push(url + (keepParams ? window.location.search : ""));
  };

  // Returns a charge confirmation url to redirect to, unless we're already on the pro plan, then redirects to that url
  activatePlan = () => {
    API.get("api", "/charge" + window.location.search)
      .then((response) => {
        if (response) {
          // If we got back a response it's going to be a URL to redirect to
          window.top.location.href = response; // Redirect to the install screen
        } else {
          console.log("already on the pro plan");
        }
      })
      .catch((error) => {
        console.log(error.response); // Otherwise log the error, if any
      });
  };

  // Returns a charge confirmation url to redirect to, unless we're already on the pro plan, then redirects to that url
  deactivatePlan = () => {
    Swal({
      title: "Are you sure?",
      text: "By downgrading, you won't be able to use any of the pro-only features including managing up to 25 toasts, targeting product pages or custom pages, and special pro-only presets. If you have more than 1 toast saved, you will lose all but your first toast saved.",
      type: "warning",
      showCancelButton: true,
      width: 600,
      backdrop: "rgba(0,0,0,0)",
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Downgrade",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.value) {
        API.get("api", "/deactivate" + window.location.search)
          .then((response) => {
            this.setState({ proStatus: false });
            Swal({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              type: "success",
              title: "Plan downgraded",
              customContainerClass: "small-swal",
            });
          })
          .catch((error) => {
            console.log(error.response); // Otherwise log the error, if any
          });
      }
    });
  };

  valueUpdater(field) {
    return (value) => this.setState({ [field]: value });
  }
}

export default Pro;
